import { language } from "~/schemas/schema.languages";
import {
  EDIT_SYSTEM_LANGUAGE_LOADING,
  EDIT_SYSTEM_LANGUAGE_SUCCESS,
  EDIT_SYSTEM_LANGUAGE_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch.jsx";

export const editSystemLanguageAction = (language_id) => {
  return {
    types: [EDIT_SYSTEM_LANGUAGE_LOADING, EDIT_SYSTEM_LANGUAGE_SUCCESS, EDIT_SYSTEM_LANGUAGE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/languages/default`,
        method: "put",
        body: {
          language_id,
        },
      }),
    payload: {
      language_id,
      schema: {
        single: language,
      },
    },
  };
};
